import { render, staticRenderFns } from "./CreateManualFailure.vue?vue&type=template&id=505359c2&scoped=true&"
import script from "./CreateManualFailure.vue?vue&type=script&lang=ts&"
export * from "./CreateManualFailure.vue?vue&type=script&lang=ts&"
import style0 from "./CreateManualFailure.vue?vue&type=style&index=0&id=505359c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505359c2",
  null
  
)

export default component.exports